import { render, staticRenderFns } from "./importProductPrice.vue?vue&type=template&id=564ab792"
import script from "./importProductPrice.vue?vue&type=script&lang=js"
export * from "./importProductPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports